var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-col', [_c('v-row', [_c('v-col', [_c('v-select', {
    attrs: {
      "items": ['auto', 'manual'],
      "label": _vm.$t('Mode'),
      "outlined": ""
    },
    on: {
      "input": function ($event) {
        return _vm.update('type', $event.target.value);
      }
    },
    model: {
      value: _vm.value.method,
      callback: function ($$v) {
        _vm.$set(_vm.value, "method", $$v);
      },
      expression: "value.method"
    }
  })], 1)], 1)], 1), _vm.value.method != 'auto' ? _c('v-card-text', [_c('v-col', [_c('v-row', {
    staticClass: "ma-auto"
  }, [_c('v-col', [_c('h4', [_vm._v(_vm._s(_vm.$t("IPv4 setting")))]), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(_vm.$t("IP address")) + " ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(_vm.$t("Mask")) + " ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(_vm.$t("Gateway")) + " ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(_vm.$t("Remove")) + " ")])])]), _c('tbody', _vm._l(_vm.value.addresses, function (item) {
          return _c('tr', {
            key: item[0]
          }, [_c('td', [_vm._v(_vm._s(_vm.intToIP(item[0])))]), _c('td', [_vm._v(_vm._s(item[1]))]), _c('td', [_vm._v(_vm._s(_vm.intToIP(item[2])))]), _c('td', [_c('v-btn', {
            staticClass: "ma-2 white--text",
            attrs: {
              "color": "red",
              "small": "",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.remove(item[0]);
              }
            }
          }, [_c('v-icon', [_vm._v(" mdi-minus ")])], 1)], 1)]);
        }), 0)];
      },
      proxy: true
    }], null, false, 327926167)
  })], 1)], 1), _c('v-row', {
    staticClass: "ma-auto"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": _vm.$t('Address')
    },
    model: {
      value: _vm.ipadress,
      callback: function ($$v) {
        _vm.ipadress = $$v;
      },
      expression: "ipadress"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": _vm.$t('Mask')
    },
    model: {
      value: _vm.mask,
      callback: function ($$v) {
        _vm.mask = $$v;
      },
      expression: "mask"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": _vm.$t('Gateway')
    },
    model: {
      value: _vm.gateway,
      callback: function ($$v) {
        _vm.gateway = $$v;
      },
      expression: "gateway"
    }
  })], 1), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "md": "3",
      "align": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Add")))])], 1)], 1), _c('v-row', {
    staticClass: "ma-auto"
  }, [_c('v-col', [_c('h4', [_vm._v(_vm._s(_vm.$t("DNS setting")))]), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(_vm.$t("DNS addresses")) + " ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(_vm.$t("Remove")) + " ")])])]), _c('tbody', _vm._l(_vm.value.dns, function (item, n) {
          return _c('tr', {
            key: n
          }, [_c('td', [_vm._v(_vm._s(_vm.intToIP(item)))]), _c('td', [_c('v-btn', {
            staticClass: "ma-2 white--text",
            attrs: {
              "color": "red",
              "small": "",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeDNS(item);
              }
            }
          }, [_c('v-icon', [_vm._v(" mdi-minus ")])], 1)], 1)]);
        }), 0)];
      },
      proxy: true
    }], null, false, 1682871921)
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": _vm.$t('Dns')
    },
    on: {
      "input": function ($event) {
        return _vm.update('type', $event.target.value);
      }
    },
    model: {
      value: _vm.dns,
      callback: function ($$v) {
        _vm.dns = $$v;
      },
      expression: "dns"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.addDNS
    }
  }, [_vm._v(_vm._s(_vm.$t("Add")))])], 1)], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }